export default "__VITE_ASSET__LjadCTpPSsUHwmhIiZAnUA__"